import { render, staticRenderFns } from "./admin_settings_history.vue?vue&type=template&id=12d0cc42&scoped=true&"
import script from "./admin_settings_history.vue?vue&type=script&lang=js&"
export * from "./admin_settings_history.vue?vue&type=script&lang=js&"
import style0 from "./admin_settings_history.vue?vue&type=style&index=0&id=12d0cc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0cc42",
  null
  
)

export default component.exports